/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
// import { useEnvStore } from '../env';
import { useAnimationsStore } from '.';
 
function useAnimations (p) {
    // const env = useEnvStore();
    const animationsStore = useAnimationsStore();
 
    useEffect(() => {

    }, [animationsStore.observed.viewFunc]);

    function renderAnimatedViews () {
        return (<React.Fragment>
            { animationsStore.renderTransitionView() }
        </React.Fragment>);
    }
    
    return {
        animationsStore,
        renderAnimatedViews,
    };
}

export default useAnimations;